import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import activityTracker from '../services/activityTracker';

/**
 * Component to automatically track page visits and route changes
 * Note: Superusers are excluded from activity tracking
 */
const ActivityTracker: React.FC = () => {
  const location = useLocation();
  const { user } = useAuth();

  useEffect(() => {
    if (!user) {
      // Stop tracking if user logs out
      activityTracker.stop();
      return;
    }

    // Skip tracking for superusers/global admins
    if (user.isGlobalAdmin) {
      activityTracker.stop();
      return;
    }

    // Track page visit when route changes
    // Note: trackPageVisit now only logs when leaving, not on entry
    const pageUrl = window.location.href;
    const pageTitle = document.title || location.pathname;

    // Track the previous page leave before starting new page
    activityTracker.trackPageLeave();

    // Start tracking new page (won't log until leaving)
    activityTracker.trackPageVisit(pageUrl, pageTitle, {
      pathname: location.pathname,
      search: location.search,
      hash: location.hash
    });

    // Cleanup: track page leave when component unmounts or route changes
    return () => {
      activityTracker.trackPageLeave();
    };
  }, [location, user]);

  return null;
};

export default ActivityTracker;

